import React from 'react';
import {View, INumber} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/pbpEntity.jsx';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    rates = {
        '2': '3.00',
        '3': '3.30',
        '4': '4.50',
        '5': '6.00',
        '6': '7.50',
        '7': '8.30',
        '8': '9.50',
        '9': '10.80',
        '10': '12.00',
        '11': '13.20',
        '12': '14.30',
        '13': '15.50',
        '14': '16.60',
        '15': '17.70',
        '16': '18.80',
        '17': '19.80',
        '18': '20.90',
        '19': '21.90',
        '20': '23.00',
        '21': '24.00',
        '22': '24.90',
        '23': '25.90',
        '24': '26.80',
        '25': '27.80'
    };
    calcBody = React.createRef();
    calcBodyWrapper = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            showSecondModal: false,
            model: {},
            mode: 'credit-line-pledge',
            payments: 2,
            capitalization: true,
            tax: true,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            calcTranslate: 0,
            calcInputValue: 0
        };

        this.state = {
            ...this.state,
            ...this._calc()
        };

        this.widgetsHelper = widgetsHelper;
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleSecondModal = this.toggleSecondModal.bind(this);

        return this;
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    openModalScreen = () => {
        const currentURL = window.location.href;
        if (currentURL.includes('pbp-entity/order')) {
            this.setState({showModal: true});
        }
    };

    openSecondModalScreen() {
        const params = new URLSearchParams(window.location.search);
        if (params.has('proposal')) {
            this.setState({showSecondModal: true});
        }
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
        this.getUrlParams();
        this.openSecondModalScreen();
    }

    componentDidUpdate() {
        const calculation = this._calc();
        const match = [
            this.state.payments !== calculation.payments,
            this.state.rate !== calculation.rate
        ];

        if (match.includes(true)) {
            this.setState({...calculation});
        }

        return this;
    }

    componentReady() {
        this.openModalScreen();
    }

    getUrlParams() {
        const params = new URLSearchParams(window.location.search);
        let paramsObj = {};

        for (const [key, value] of params) {
            paramsObj[key] = value;
        }
        this.setState({utmParams: paramsObj});
    }

    _calc() {
        const payments = new INumber(this.state.payments).toString(null, null, true, 0);
        const rate = this.rates[payments];

        return {
            payments: new INumber(payments).toString(null, null, true, 0),
            rate: rate.toString() + '%'
        };
    }

    onCalcChange(value) {
        const calcBodyWrapperOffset = this.calcBodyWrapper.current.offsetWidth;
        const calcBodyOffset = this.calcBody.current.offsetWidth;
        const calcTranslate = Math.abs(
            (value * (calcBodyWrapperOffset - calcBodyOffset)) / (calcBodyOffset / 100) / 100
        );
        this.setState({calcTranslate, calcInputValue: value});
    }

    toggleSecondModal() {
        this.setState({showSecondModal: !this.state.showSecondModal});
    }

    static displayName = 'Business.Views.PBP';

    static contextTypes = {
        app: PropTypes.object
    };
}
